import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

import { MatriculaGestaoModel } from '@models/gestao/matricula-gestao.model';
import { MatriculaLogModel } from '@core/models/log/matricula-log.model';
import { LogService } from '../log.service';

@Injectable({
  providedIn: 'root',
})
export class MatriculaLogPorIdResolver implements Resolve<MatriculaLogModel> {

  constructor(
    private _service: LogService
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<MatriculaLogModel> {
    return this._service
      .getById(route.params.id)
      .pipe(
        map(res => {
          if (res instanceof MatriculaLogModel) {
            return res as MatriculaLogModel;
          }
          return new MatriculaLogModel();
        }),
        catchError(() => of(new MatriculaLogModel()))
      );
  }
}

